<template>
  <div
    id="Benefits"
    class="relative bg-white"
  >
    <div class="mx-auto max-w-3xl px-8 py-10 md:py-10 lg:max-w-6xl lg:py-14">
      <div class="mb-10 mt-10 md:mb-10 md:mt-10 lg:mb-14 lg:mt-14">
        <div class="relative mx-auto max-w-full text-center lg:max-w-2xl">
          <span class="mb-1 block text-sm font-medium uppercase text-gray-900">Features</span>
          <h2
            class="relative text-2xl font-semibold leading-tight tracking-tight text-[#20484F] md:text-4xl lg:text-[2.7em] lg:leading-tight"
          >
            <span class="span-underline">Save Time</span> Understanding and
            Managing your Carbon Footprint with Veridis
          </h2>
        </div>
      </div>

      <div class="grid grid-cols-2 gap-4 lg:grid-cols-4 lg:gap-4">
        <BenefitCard
          v-for="(benefit, index) in benefits"
          :key="index"
          :text="benefit"
        />
        <div
          class="lg:justify-bottom mb-4 rounded-lg border border-green-800/50 bg-green-700 px-5 py-5 hover:shadow-sm lg:mb-0 lg:flex lg:px-10"
        >
          <div class="flex items-center justify-center">
            <div
              class="text-base font-medium leading-tight text-white lg:text-base lg:leading-tight"
            >
              And<br>
              more features
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BenefitsSection',

  data() {
    return {
      benefits: [
        'Streamlined and verifiable data collection',
        'Emissions calculation aligned with GHG protocol',
        'Intuitive, customizable, and powerful calculations capabilities',
        'Visibility to data across the supply chain',
        'Extensive catalog of emissions factors',
        'Support for a multitude of reporting protocols and formats',
        'Instant report generation',
        'Tailored sustainability roadmap',
        'Start as you are and grow as your capabilities mature',
      ],
    }
  },
}
</script>

<style>
.hovering {
  -webkit-animation-name: hovering;
  -webkit-animation-duration: 6s;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-timing-function: ease-in-out;
  -moz-animation-name: hovering;
  -moz-animation-duration: 6s;
  -moz-animation-iteration-count: infinite;
  -moz-animation-timing-function: ease-in-out;
  animation-name: hovering;
  animation-duration: 6s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
}

@-webkit-keyframes hovering {
  from {
    -webkit-transform: translate(0, 0px);
  }

  50% {
    -webkit-transform: translate(0, -15px);
  }

  to {
    -webkit-transform: translate(0, -0px);
  }
}

@-moz-keyframes hovering {
  from {
    -moz-transform: translate(0, 0px);
  }

  50% {
    -moz-transform: translate(0, -15px);
  }

  to {
    -moz-transform: translate(0, -0px);
  }
}

@keyframes hovering {
  from {
    transform: translate(0, 0px);
  }

  50% {
    transform: translate(0, -15px);
  }

  to {
    transform: translate(0, -0px);
  }
}
</style>
